import { type ReactNode, useState } from "react";

import { trpc } from "@blis/trpc/react";

import { ConfirmPrompt } from "@/components/ConfirmPrompt";
import { mutationResponse } from "@/utils/trpc";

export function RemoveResultNotificationDialog({
  org,
  testSpecId,
  children,
}: {
  children: ReactNode;
  org: { id: number };
  testSpecId: number;
}) {
  const [open, setOpen] = useState(false);
  const deleteNotification =
    trpc.admin.org.deleteTestResultNotification.useMutation();

  const confirm = () => {
    deleteNotification.mutate(
      {
        testSpecId,
        orgId: org.id,
      },
      mutationResponse({
        errorTitle: "Error removing email notification",
        successMessage: "Email notification removed",
        onSuccess() {
          setOpen(false);
        },
      }),
    );
  };

  return (
    <ConfirmPrompt
      open={open}
      onOpenChange={setOpen}
      onConfirm={confirm}
      title="Remove notification"
      message="Are you sure you want to remove this notification?"
      loading={deleteNotification.isPending}
      danger
    >
      {children}
    </ConfirmPrompt>
  );
}
